import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import sfsu_logo from "../Images/sfsu_logo.png";

const AppHeader = ({ titleSize = "text-5xl", bgClass = "bg-white", textClass = "text-primary" }) => {
  const navigate = useNavigate();
  const [session, setSession] = useState(null);
  const userMetadata = session?.user?.user_metadata || {};
  const firstName = (userMetadata.first_name || "").trim();
  const lastName = (userMetadata.last_name || "").trim();
  const userInitials =
    firstName && lastName
      ? `${firstName[0]}${lastName[0]}`.toUpperCase()
      : (session?.user?.email || "?")[0].toUpperCase();

  useEffect(() => {
    let isMounted = true;

    if (!supabase || !supabase.auth) {
      return undefined;
    }

    const loadSession = async () => {
      const {
        data: { session: currentSession },
      } = await supabase.auth.getSession();

      if (isMounted) {
        setSession(currentSession);
      }
    };

    loadSession();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, currentSession) => {
      setSession(currentSession);
    });

    return () => {
      isMounted = false;
      subscription.unsubscribe();
    };
  }, []);

  const handleLogout = async () => {
    if (!supabase || !supabase.auth) return;
    await supabase.auth.signOut();
  };

  return (
    <header className={`${bgClass} ${textClass} px-12 py-4 flex items-center justify-between`}>
      <h1
        className={`${titleSize} font-bold cursor-pointer hover:underline`}
        onClick={() => navigate("/")}
      >
        DeepToast
      </h1>

      <div className="flex items-center gap-4">
        {session ? (
          <div className="flex flex-col items-center gap-2">
            <div className="w-10 h-10 rounded-full bg-primary text-white font-semibold flex items-center justify-center">
              {userInitials}
            </div>
            <button
              type="button"
              onClick={handleLogout}
              className="text-sm text-primary underline underline-offset-2 hover:opacity-80 transition"
            >
              Logout
            </button>
          </div>
        ) : null}
        <img src={sfsu_logo} alt="SFSU Logo" className="w-20 h-20 object-contain" />
      </div>
    </header>
  );
};

export default AppHeader;
